import React, { useEffect, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/edit.module.css";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { useLocation, useParams } from "react-router";
import Alert from "../../../Components/Alert/alert";
import { Url, getUser } from "../../../Constants/globals";
import Dropdown from "../../../Components/Dropdown/dropdown";
import GoBack from "../../../Components/GoBack/goback";

async function getCompanies() {
  try {
    const res = await axios.get(`${Url}/companies?per_page=300`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCompanies();
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getUnitDetails(id){
  try {
    const res = await axios
    .get(`${Url}/units/${id}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getUnitDetails(id);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function addCampaign(nome, company){
  if (nome === "") {
    return <Alert type={"error"}>O nome é obrigatório</Alert>;
  }
  else if (company === "") {
    return <Alert type={"error"}>A empresa é obrigatória</Alert>;
  }
  try {
    await axios.post(`${Url}/units`,
    {
      name: nome,
      company_id: company.id
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return <Alert type={"success"}>Unidade adicionada com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await addCampaign(nome, company);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a unidade");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a unidade"}</Alert>;
    }
  };
}

async function saveCampaign(id, nome, company){
  if (nome === "") {
    return <Alert type={"error"}>O nome é obrigatório</Alert>;
  }
  else if (company === "") {
    return <Alert type={"error"}>A empresa é obrigatória</Alert>;
  }
  try {
    await axios.put(`${Url}/units/${id}`,
    {
      name: nome,
      company_id: company.id
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return <Alert type={"success"}>Unidade editada com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await saveCampaign(id, nome, company);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a unidade");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a unidade"}</Alert>;
    }
  };
}

function EditarUnidades({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const [loadingData, setLoadingData] = useState(true);
  const [alert, setAlert] = useState("");

  const [nome, setNome] = useState("");

  const [companies, setCompanies] = useState([]);
  const [companyValue, setCompanyValue] = useState("");

  async function assignData() {
    const thisUnitDetailsData = await getUnitDetails(id);
    setNome(thisUnitDetailsData.name ?? "");
    setCompanyValue(thisUnitDetailsData.company ?? "")
    setLoadingData(false);
  }

  async function fetchCompanies() {
    const thisCompaniesData = await getCompanies();
    setCompanies(thisCompaniesData.companies);
  }

  useEffect(() => {
    fetchCompanies();
  }, []);

  async function getAlertEdit() {
    await setAlert("");
    const res = await saveCampaign(id, nome, companyValue);
    setAlert(res);
  }

  async function getAlertAdd() {
    await setAlert("");
    const res = await addCampaign(nome, companyValue);
    setAlert(res);
  }
  
  useEffect(() => {
    if (id)
      assignData();
    else {
      setLoadingData(false);
    }
  }, []);

  return (
    <div className="body">
      {alert}
      <NavBar current={"unidades"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div className={styles.content}>
          <GoBack backRoute={`/unidades`} backState={state?.page ? {page: state.page} : {}} />
          {
            id ?
            <h1 className={styles.backgroundName}>Editar unidade</h1>
            :
            <h1 className={styles.backgroundName}>Adicionar unidade</h1>
          }
          <div className={styles.formBlock}>
            <div className={styles.formBlockSection}>
              <p>Nome:</p>
              <input
                defaultValue={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </div>
            <Dropdown
              label={"Empresa:"}
              placeholder={"Escolher empresa"}
              items={companies}
              onUrlChange={fetchCompanies}
              value={companyValue}
              onValueChange={setCompanyValue}
            />
          </div>
          {
            id ?
            <button className={styles.btn} onClick={() => getAlertEdit()}>Guardar alterações</button>
            :
            <button className={styles.btn} onClick={() => getAlertAdd()}>Adicionar unidade</button>
          }
        </div>
      }
    </div>
  );
}

export default EditarUnidades;